/**
 * SurveyEntryBanner · AI 图像识别问卷入口横幅
 *
 * 展示在 AI 助手会话 Composer 输入框上方（视觉对齐 Figma 分类agent
 * node 12:3097），点击任意位置在屏幕中间弹出「内测申请」弹窗
 * （AiPhotoBetaModal · 自包含：名额 / 下单 / 支付 / 留资上报全内置）。
 */

import React, { useCallback, useState } from 'react'
import AiPhotoBetaModal from '../../../ai-photo-king/components/AiPhotoBetaModal'
import { trackAIChatClick } from '../../utils/trackClassify'
import { ArrowRightIcon, PhotoRecognitionIcon } from './icons'
import styles from './SurveyEntryBanner.module.scss'

/** 来源标识 · 支付成功上报带给后端，按入口区分转化数据 */
const BETA_APPLY_SOURCE = 'ai_classify_chat_banner'

const SurveyEntryBanner: React.FC = () => {
  const [betaModalOpen, setBetaModalOpen] = useState(false)

  const handleOpenSurvey = useCallback(() => {
    trackAIChatClick('surveyEntry')
    setBetaModalOpen(true)
  }, [])

  return (
    <>
      <div
        className={styles.banner}
        role="button"
        tabIndex={0}
        onClick={handleOpenSurvey}
      >
        <span className={styles.iconBox}>
          <PhotoRecognitionIcon />
        </span>
        <span className={styles.textArea}>
          <span className={styles.title}>
            不止认水印，AI 还能看懂照片里“拍了什么”
          </span>
          <span className={styles.subtitle}>
            按标牌 / 设备 / 隐患等画面内容分类 ——
            <span className={styles.link}>填问卷优先体验</span>
          </span>
        </span>
        <ArrowRightIcon />
      </div>

      {/* 内测申请弹窗 · 无客服会话入口，不传 onContactService（按钮自动隐藏） */}
      <AiPhotoBetaModal
        visible={betaModalOpen}
        onClose={() => setBetaModalOpen(false)}
        source={BETA_APPLY_SOURCE}
      />
    </>
  )
}

export default SurveyEntryBanner
